export default __webpack_public_path__ + "static/announce_w.77198e540a6ad692e02712c6ba278c19.png";